import { ColumnsType } from 'antd/lib/table';
import { ReactNode } from 'react';
import { formatMass } from 'core/utils/numbers';
import { GoodsShipmentItem } from 'store/declarations/ireland/import-declaration';

type RenderValue = (value: string | number | ReactNode | undefined, index: number) => any;

// The reduced, mirroring-specific column set (commodity code, TARIC code and description split
// out as their own columns, packaging split into type/count) shared by the item errors table and
// the "fix missing field" modal's item summary - keeping both views in sync.
export const getIrelandH1ItemColumns = (renderValue: RenderValue): ColumnsType<GoodsShipmentItem> => [
    {
        title: 'Commodity Code',
        key: 'commodity_code',
        render: (_, record: GoodsShipmentItem, index: number) =>
            renderValue(record?.goodsInformation?.combinedNomenclatureCode, index),
    },
    {
        title: 'Taric Code',
        key: 'taric_code',
        render: (_, record: GoodsShipmentItem, index: number) =>
            renderValue(record?.goodsInformation?.taricCode, index),
    },
    {
        title: 'Description',
        key: 'description_of_goods',
        render: (_, record: GoodsShipmentItem, index: number) =>
            renderValue(record?.goodsInformation?.goodsDescription, index),
    },
    {
        title: 'Net Mass',
        key: 'net_mass',
        align: 'right',
        render: (_, record: GoodsShipmentItem, index: number) =>
            renderValue(formatMass(record?.goodsInformation?.netMass), index),
    },
    {
        title: 'Pkgs Count',
        align: 'right',
        key: 'packages_count',
        render: (_, record: GoodsShipmentItem, index: number) =>
            renderValue(record?.goodsInformation?.packaging?.[0]?.packageNumber, index),
    },
    {
        title: 'Pkgs Type',
        key: 'packages_type',
        render: (_, record: GoodsShipmentItem, index: number) =>
            renderValue(record?.goodsInformation?.packaging?.[0]?.typePackage, index),
    },
];
